export default "__VITE_ASSET__CmmDYFbR__"